/**
 * Validation Errors Alert
 * Displays backend dependency validation errors
 */

import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

export function ValidationErrorsAlert({ errors }) {
  if (!errors || Object.keys(errors).length === 0) {
    return null;
  }

  return (
    <Alert variant="destructive" data-testid="validation-errors-alert">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle className="heading-font">Configuration Issues</AlertTitle>
      <AlertDescription className="space-y-2 mt-2">
        {Object.entries(errors).map(([key, messages]) => (
          <div key={key} className="space-y-1">
            <p className="text-sm font-medium capitalize">{key.replace(/_/g, ' ')}</p>
            <ul className="list-disc list-inside space-y-1 text-xs">
              {messages.map((msg, idx) => (
                <li key={idx}>{msg}</li>
              ))}
            </ul>
          </div>
        ))}
      </AlertDescription>
    </Alert>
  );
}
